import React, { useCallback, useEffect, useState } from "react";
import AppTheme from "../../../theme/AppTheme";
import CssBaseline from "@mui/material/CssBaseline";
import { Box, Card, useMediaQuery, useTheme } from "@mui/material";
import OrdersHistory from "../../OrdersHistory/OrdersHistory";
import { getInvoiceLists, getInvoiceById } from "../../../service/Invoice/invoice";
import { useParams } from "react-router-dom";
import StoreHeader from "../../../components/StoreHeader/StoreHeader";

export default function OrderHistoryTab(props: { disableCustomTheme?: boolean }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { store_id } = useParams();

  const [invoiceList, setInvoiceList] = useState<any[]>([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);

  const fetchInvoiceList = useCallback(
    async (pageNo: number = 1) => {
      if (loading || (pageNo > totalPages && pageNo !== 1)) return;

      setLoading(true);
      try {
        const res = await getInvoiceLists(pageNo, store_id, 10); // pass page & limit
        const data = res?.data?.data?.invoice || [];
        const total = res?.data?.data?.totalPages || 1;

        setInvoiceList((prev) => (pageNo === 1 ? data : [...prev, ...data]));
        setTotalPages(total);
        setPage(pageNo);
      } catch (err) {
        console.error("Error fetching invoices:", err);
        if (pageNo === 1) setInvoiceList([]);
      } finally {
        setLoading(false);
      }
    },
    [store_id, totalPages, loading]
  );

  useEffect(() => {
    setInvoiceList([]);
    setPage(1);
    fetchInvoiceList(1);
  }, [store_id]);

  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (scrollHeight - scrollTop <= clientHeight + 50 && !loading) {
      if (page < totalPages) {
        fetchInvoiceList(page + 1);
      }
    }
  };

  return (
    <AppTheme {...props}>
      <CssBaseline enableColorScheme />
      <Box sx={{ width: "100%", height: "100%", pt: isMobile ? 5 : 0 }}>
        <StoreHeader />
        <Card
          sx={{
            position: "relative",
            backgroundColor: "white",
            maxHeight: "calc(100vh - 80px)",
            borderRadius: "8px",
          }}
        >
          <OrdersHistory />
        </Card>
      </Box>
    </AppTheme>
  );
}
